module.exports = __webpack_public_path__ + "static/media/engel.483c8b41.webp";